import { NetworkActionPrefix, ActionType } from '../utils/constants';
import { MarketRSSWatchSettingApi, MarketRSSWatchSettingFeedDataApi, MarketRSSWatchSettingReportApi } from 'for-straction-service-api';
import { networkAPIAction, droppableNetworkAPIAction } from '../utils/actionCreatorsFactory';
import { isInternalID } from '../api/utils';

const rssSettingsAPI = new MarketRSSWatchSettingApi();
const rssSettingsReportAPI = new MarketRSSWatchSettingReportApi();
const rssSettingsFeedDataAPI = new MarketRSSWatchSettingFeedDataApi();

const rssSettings = {
    loadAllMarketRssSettings: () => droppableNetworkAPIAction(rssSettingsReportAPI, 'marketRSSWatchSettingReportLoadAllGet', NetworkActionPrefix.LOAD_MARKET_RSS_WATCH_SETTINGS_LIST_PREFIX),

    setMarketRssSettingsName: (name) => ({ type: ActionType.SET_MARKET_RSS_SETTINGS_NAME, name }),
    setMarketRssSettingsTargetURL: (targetURL) => ({ type: ActionType.SET_MARKET_RSS_SETTINGS_TARGET_URL, targetURL }),
    setMarketRssSettingsPESTELArea: (pestelAreaID) => ({ type: ActionType.SET_MARKET_RSS_SETTINGS_PESTEL_AREA, pestelAreaID }),
    setMarketRssSettingsSWOTTopic: (swotTopicID) => ({ type: ActionType.SET_MARKET_RSS_SETTINGS_SWOT_TOPIC, swotTopicID }),
    setMarketRssSettingsPersonalTopic: (personalTopicID) => ({ type: ActionType.SET_MARKET_RSS_SETTINGS_PERSONAL_TOPIC, personalTopicID }),
    setMarketRssSettingsTrendTopic: (trendTopicID) => ({ type: ActionType.SET_MARKET_RSS_SETTINGS_TREND_TOPIC, trendTopicID }),
    setMarketRssSettingsStakeholderID: (stakeholderID) => ({ type: ActionType.SET_MARKET_RSS_SETTINGS_STAKEHOLDER_ID, stakeholderID }),
    setMarketRssSettingsCompanyLegalEntityID: (companyLegalEntityID) => ({ type: ActionType.SET_MARKET_RSS_SETTINGS_COMPANY_LEGAL_ENTITY_ID, companyLegalEntityID }),
    setMarketRssSettingsCompanyFunctionID: (companyFunctionID) => ({ type: ActionType.SET_MARKET_RSS_SETTINGS_COMPANY_FUNCTION_ID, companyFunctionID }),
    setMarketRssSettingsModerator: (moderatorID) => ({ type: ActionType.SET_MARKET_RSS_SETTINGS_MODERATOR, moderatorID }),

    marketRssSettingOpenForEdit: (ID) => ({ type: ActionType.MARKET_RSS_SETTING_OPEN_FOR_EDIT, ID }),

    saveCurrentlyEditedRssSettingValidationResults: validationResult => ({ type: ActionType.VALIDATE_EDITABLE_RSS_SETTING_INPUTS, validationResult }),

    loadRssPreview: targetURL => networkAPIAction(rssSettingsFeedDataAPI, 'marketRSSWatchSettingFeedDataLoadPreviewGet', NetworkActionPrefix.MARKET_RSS_WATCH_SETTING_LOAD_PREVIEW_PREFIX, { targetURL }, targetURL), //todo: change action prefix constant to relevant

    syncMarketRssSettings: (marketRssSetting) => {
        if (isInternalID(marketRssSetting.ID)) {
            return networkAPIAction(rssSettingsReportAPI, 'marketRSSWatchSettingReportAddSettingSaveFeedAndLoadReportPut', NetworkActionPrefix.ADD_MARKET_RSS_WATCH_SETTING_PREFIX, {
                ID: marketRssSetting.ID,
                marketRssSetting
            }, marketRssSetting);
        } else {
            return networkAPIAction(rssSettingsAPI, 'marketRSSWatchSettingEditPut', NetworkActionPrefix.EDIT_MARKET_RSS_WATCH_SETTING_PREFIX, {
                ID: marketRssSetting.ID,
                marketRssSetting
            }, marketRssSetting, marketRssSetting.ID);
        }
    },

    saveEditedMarketRssSetting: (marketRssSetting) => {
        return (dispatch, getState) => {
            dispatch({ type: ActionType.SAVE_MARKET_RSS_SETTING, marketRssSetting, ID: marketRssSetting.ID });

            return dispatch(rssSettings.syncMarketRssSettings(marketRssSetting));
        };
    },

    deleteMarketRssSetting: (settingId) => {
        return networkAPIAction(rssSettingsAPI, 'marketRSSWatchSettingDeleteGet', NetworkActionPrefix.DELETE_MARKET_RSS_WATCH_SETTING_PREFIX, { ID: settingId }, settingId);
    },

    refreshMarketRssSettingFeedData: (settingId, reportRenderMethod) => {
        return (dispatch, getState) => networkAPIAction(rssSettingsReportAPI, 'marketRSSWatchSettingReportUpdateFeedDataWithLatestEntriesAndLoadReportGet', NetworkActionPrefix.UPDATE_RSS_FEED_ENTRIES_AND_LOAD_MARKET_RSS_WATCH_SETTING_REPORT_PREFIX, { ID: settingId }, settingId)(dispatch, getState)
            .then(response => {
                dispatch(rssSettings.showMarketRssSettingFeedDataRefreshReport(reportRenderMethod, response));
            });
    },

    showMarketRssSettingFeedDataRefreshReport: (renderMethod, report) => rssSettings.showModalWindowOnRssSettingsPage(renderMethod, { report }),

    showModalWindowOnRssSettingsPage: (renderMethod, renderParams) => ({ type: ActionType.SHOW_MODAL_WINDOW_ON_RSS_SETTINGS_PAGE, renderMethod, renderParams }),
    closeModalWindowOnRssSettingsPage: modalId => ({ type: ActionType.CLOSE_MODAL_WINDOW_ON_RSS_SETTINGS_PAGE, modalId }),
    closeAllModalWindowsOnRssSettingsPage: () => ({ type: ActionType.CLOSE_ALL_MODAL_WINDOWS_ON_RSS_SETTINGS_PAGE })

};

export default rssSettings;